import { STATUS, USER_TYPE_GUEST } from '@app/constants/commonConstants';
import { AlloyButton, Popup, SaveIcon } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { iconSize } from '../constants';
import OrderItemsHeaderActionsItems from './OrderItemsHeaderActionsItems';

const OrderItemsHeaderActions = () => {
  const [t] = useTranslation();
  const downloadLabel = t('SAVE');

  const shoppingPreferenceDataStatus = useSelector(
    s => s.shoppingPreferences.shoppingPreferenceDataStatus
  );
  const isOrderPriceAvailabilityLoading = useSelector(
    s => s.orders?.isOrderPriceAvailabilityLoading
  );
  const getCurrentOrderStatus = useSelector(
    s => s.orders?.getCurrentOrderStatus
  );
  const userType = useSelector(state => state.common.userType);
  const isLoggedIn = !!(userType && userType !== USER_TYPE_GUEST);
  const shoppingPreferencesLoaded =
    shoppingPreferenceDataStatus === STATUS.REJECTED ||
    shoppingPreferenceDataStatus === STATUS.RESOLVED;
  const isOrdersLoading =
    getCurrentOrderStatus === STATUS.IDLE ||
    getCurrentOrderStatus === STATUS.PENDING;
  const hasOrdersAndShoppingPreferencesResolved = isLoggedIn
    ? !isOrdersLoading &&
      shoppingPreferencesLoaded &&
      !isOrderPriceAvailabilityLoading
    : !isOrdersLoading && !isOrderPriceAvailabilityLoading;

  const actionsInitiator = (
    <AlloyButton
      aria-label={downloadLabel}
      buttonType="ghost"
      className="d-inline-flex align-items-center mt-2 mt-md-0 ms-0 ms-md-n2 mb-4 mb-md-0 p-0"
      disabled={!hasOrdersAndShoppingPreferencesResolved}
    >
      <SaveIcon
        title={downloadLabel}
        aria-label={`${downloadLabel}-icon`}
        width={iconSize}
        height={iconSize}
        className="d-none d-md-inline-block me-2"
      />
      <div className="u-fs--16 ps-md-1 ps-lg-0">{downloadLabel}</div>
    </AlloyButton>
  );
  return (
    <Popup
      id="shopping-cart-save-actions"
      contents={<OrderItemsHeaderActionsItems />}
      initiator={actionsInitiator}
      className="p-0 mt-2 border-0"
      popperOptions={{
        placement: 'bottom-end',
        enabled: hasOrdersAndShoppingPreferencesResolved
      }}
    />
  );
};

export default OrderItemsHeaderActions;
